{
  "eyebrow": "CÂU CHUYỆN CỦA CHÚNG TÔI",
  "title": "Một căn bếp đẹp.\nNhiều niềm vui hơn.",
  "intro": "SUII tìm cảm hứng từ những điều giản dị: một căn bếp ngập nắng, món ăn tự tay làm và khoảnh khắc quây quần bên nhau.",
  "heroImage": "/site-images/hero/hero-04.png",
  "storyTitle": "Chăm chút căn bếp,\ntrân trọng mỗi ngày.",
  "story": [
    "Với SUII, căn bếp không chỉ là nơi nấu ăn. Đó còn là nơi bắt đầu một ngày mới, thử một công thức lạ và chia sẻ sự quan tâm qua từng bữa cơm.",
    "Chúng tôi mong muốn đưa sự hài hòa giữa công năng và thẩm mỹ vào không gian quen thuộc ấy — để những việc nhỏ mỗi ngày cũng trở thành một niềm vui."
  ],
  "storyImage": "/site-images/hero/hero-02.png",
  "values": [
    { "icon": "design", "title": "Đẹp một cách gần gũi", "text": "Màu sắc dịu dàng, đường nét tinh tế, dễ hòa vào nhịp sống và không gian của bạn." },
    { "icon": "cooking", "title": "Thiết thực mỗi ngày", "text": "Từ chuẩn bị nguyên liệu đến hoàn thành bữa ăn, cảm hứng bắt đầu từ những điều dễ làm." },
    { "icon": "heart", "title": "Thêm những phút bên nhau", "text": "Một bữa sáng chậm rãi hay bữa tối ấm áp đều là dịp để kết nối và sẻ chia." }
  ],
  "lifeTitle": "Từ căn bếp nhỏ,\nđến những khoảnh khắc lớn.",
  "lifeText": "Khám phá những cách nấu quen mà mới, chọn món mình thích và cùng SUII tạo nên nhịp sống của riêng bạn.",
  "lifeImage": "/site-images/hero/hero-01.png",
  "ctaTitle": "Niềm vui tiếp theo\nbắt đầu từ căn bếp.",
  "ctaText": "Một công thức dễ làm có thể là khởi đầu cho một ngày thật khác."
}
